export default {"src":"/frontend-static/_next/static/media/email.738b8876.svg","height":447,"width":340,"blurWidth":0,"blurHeight":0};